import { Skeleton } from '@mui/material';
const AcquisitionPageLoader = () => {
    return (
        <div>
            <div style={{ padding: '16px' }}>
                <Skeleton variant="rectangular" width={'100%'} height={200} />
            </div>
            <div
                style={{
                    padding: '16px',
                    display: 'flex',
                    gap: '5px',
                    flexDirection: 'row',
                }}
            >
                <Skeleton variant="rectangular" width={'100%'} height={100} />
                <Skeleton variant="rectangular" width={'100%'} height={100} />
            </div>
            <div
                style={{
                    padding: '16px',
                    display: 'flex',
                    gap: '5px',
                    flexDirection: 'column',
                }}
            >
                <Skeleton variant="rectangular" width={'100%'} height={50} />
                <Skeleton variant="rectangular" width={'100%'} height={50} />
                <Skeleton variant="rectangular" width={'100%'} height={50} />
                <Skeleton variant="rectangular" width={'100%'} height={50} />
            </div>
        </div>
    );
};

export default AcquisitionPageLoader;
